import { Suspense, lazy, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { postWindowCloseMessage } from './utils/requests';
import SuspenseRouter from './suspense-router';

const ErrorMessage = lazy(() => import('./components/error-message'));
const Home = lazy(() => import('./pages/home'));
const BasicDetails = lazy(() => import('./components/modals/basic-details'));
const Prefill = lazy(() => import('./pages/prefill'));
const EffectiveDate = lazy(() => import('./components/modals/effective-date'));
const CarrierQuotes = lazy(() => import('./pages/carrier-quotes'));
const CarrierDetails = lazy(() => import('./pages/carrier-details'));
const CarrierQuotesMain = lazy(() => import('./pages/carrier-quotes/carrier-quotes-main'));
const CoteriePaymentFlow = lazy(() => import('./pages/coterie'));
const ReviewOrderCoterie = lazy(() => import('./pages/coterie/review-order'));
const CustomizeCoverageCoterie = lazy(() => import('./pages/coterie/customize-coverage'));
const JobSearch = lazy(() => import('./components/modals/job-search'));
const OrderConfirmationCoterie = lazy(() => import('./pages/coterie/confirmation'));
const Additional = lazy(() => import('./pages/additional'));
const BusinessFormSet = lazy(() => import('./components/modals/prefill/business-info-details'));
const BusinessLocationFormSet = lazy(() => import('./components/modals/prefill/business-info-location'));
const PersonalFormSet = lazy(() => import('./components/modals/prefill/business-info-personal-details'));
const BusinessOperations = lazy(() => import('./components/modals/business-info-operations'));
const CABodilyInjury = lazy(() => import('./components/modals/ca-bodily-injury'));
const FeinInfo = lazy(() => import('./components/modals/fein-info'));
const BuildingInfo = lazy(() => import('./components/modals/building-info'));
const CoverageFormSet = lazy(() => import('./pages/coverage'));
const QuotesLoading = lazy(() => import('./pages/quotes-loading'));

export default function App() {
  const init = async () => {
    if (process.env.REACT_APP_USE_COUNTERS === '1') {
      TagManager.initialize({
        gtmId: 'GTM-5G754CZ',
      });
    }
    if (sessionStorage.getItem('unloaded')) {
      sessionStorage.removeItem('unloaded');
      await postWindowCloseMessage(true);
    }
  };

  useEffect(() => {
    init();
    window.addEventListener('beforeunload', async e => {
      sessionStorage.setItem('unloaded', 'true');
      await postWindowCloseMessage(false);
    });
    return () => {
      window.removeEventListener('beforeunload', () => {
        sessionStorage.setItem('unloaded', 'true');
      });
    };
  }, []);

  return (
    <>
      <ErrorMessage />
      <SuspenseRouter window={window}>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home isNew={true} />}>
              <Route index element={<CoverageFormSet isNew={true} />} />
              <Route element={<Prefill />}>
                <Route path="/business-information" element={<BusinessFormSet />} />
                <Route path="/business-location" element={<BusinessLocationFormSet />} />
                <Route path="/personal-information" element={<PersonalFormSet />} />
              </Route>
              <Route path="jobs" element={<JobSearch />} />
              <Route path="operations" element={<BusinessOperations />} />
              <Route path="business-size" element={<BasicDetails />} />
              <Route path="effective-date" element={<EffectiveDate />} />
              <Route path="bodily-injury" element={<CABodilyInjury />} />
              <Route path="fein-info" element={<FeinInfo />} />
              <Route path="building-info" element={<BuildingInfo />} />
            </Route>
            <Route path="/" element={<Additional />}>
              <Route path="/quotes-loading" element={<QuotesLoading />} />
            </Route>
            <Route path="/carrier-quotes" element={<CarrierQuotes />}>
              <Route index element={<CarrierQuotesMain />} />
              <Route path=":id/:bypass" element={<CarrierDetails />} />
            </Route>
            <Route path="/purchase/coterie" element={<CoteriePaymentFlow />}>
              <Route path="customize" element={<CustomizeCoverageCoterie />}></Route>
              <Route path="review-order" element={<ReviewOrderCoterie />}></Route>
              <Route path="confirmation" element={<OrderConfirmationCoterie />}></Route>
            </Route>
          </Routes>
        </Suspense>
      </SuspenseRouter>
    </>
  );
}
